import { ETransportTargetFreightPlutoDto } from '@/generated/model';

export interface FreightDataChange {
  targetFreights?: ETransportTargetFreightPlutoDto | undefined;
  isSyncAdded?: boolean | undefined;
}

export const TIME_FILTER_TABS = ['All', 'Active', 'Future', 'Inactive'] as const;
export type TimeFilterTabs = (typeof TIME_FILTER_TABS)[number];
